var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanPersonalDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 13.1038H21.25M29.75 2.83301H4.25M29.75 20.8955H21.25M29.75 31.1663H4.25",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8667 20.5813H11.2768C9.85327 20.5813 9.14154 20.5813 8.56238 20.7576C7.25841 21.1543 6.23799 22.1779 5.84243 23.4859C5.66675 24.0669 5.66675 24.7808 5.66675 26.2087M18.4167 12.3962C18.4167 14.939 16.3617 17.0003 13.8267 17.0003C11.2918 17.0003 9.23675 14.939 9.23675 12.3962C9.23675 9.85335 11.2918 7.79199 13.8267 7.79199C16.3617 7.79199 18.4167 9.85335 18.4167 12.3962Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanPersonalDetail);
export default __webpack_public_path__ + "static/media/carePlanPersonalDetail.0ad603f0624378d4700830be2cd46f72.svg";
export { ForwardRef as ReactComponent };